import {Euler, Object3D, Vector3} from "three";
import Action from '../classes/Action';
import {ActionDescription, ActionParameters}   from '../classes/api/APIDecorators';
import DefaultSceneManager from '../classes/DefaultSceneManager';
import { CustomEventTypes, SaveModificationTypes } from '../globals';
import Scenario from "../classes/scenarioElements/Scenario";
import ProjectSaver from '../classes/ProjectSaver';
import MathUtils from '../classes/utilities/MathUtils';
import {RegisterActionWithAPI} from "../classes/api/Decorators";

@ActionDescription("Sets the rotation of the selected objects.")
@ActionParameters({objects: "Object3D[]", newRotations: "Euler[]", oldRotations: "Euler[]", newPositions: "Vector3[]", oldPositions: "Vector3[]"})
@RegisterActionWithAPI("SetObjectRotationAction")
export default class SetObjectRotationAction extends Action
{
	constructor(objects: Object3D[], newRotations: Euler[], oldRotations: Euler[], newPositions: Vector3[] | null = null, oldPositions: Vector3[] | null = null)
	{
		const actionName = objects.length > 1 ? "Rotated objects" : (objects.length === 1 ? "Rotated " + objects[0].name : "No objects to rotate");
		const isDefaultState = Scenario.currentStep()?.isDefault();

		super([objects, newRotations, newPositions, isDefaultState],
			[objects, oldRotations, oldPositions, isDefaultState],
			actionName,
			[objects, newRotations, oldRotations]);
	}

	do(objects: Object3D[], rotations:Euler[], positions: Vector3[], isDefaultState: boolean)
	{
		if (isDefaultState)
		{
			DefaultSceneManager.getInstance().syncNativeObjectVectorProperty(objects, 'rotation', rotations);
			if (positions)
			{
				DefaultSceneManager.getInstance().syncNativeObjectVectorProperty(objects, 'position', positions);
			}
		}

		for (let i = 0; i < objects.length; i++)
		{
			const object = objects[i];
			object.rotation.copy(rotations[i]);
			ProjectSaver.getInstance().markModifiedObject(object, SaveModificationTypes.Rotation);
			if (positions)
			{
				object.position.copy(positions[i]);
				ProjectSaver.getInstance().markModifiedObject(object, SaveModificationTypes.Position);
			}
		}

		document.dispatchEvent(new CustomEvent(CustomEventTypes.selectedObjectRotationChanged));
		if (positions)
		{
			document.dispatchEvent(new CustomEvent(CustomEventTypes.selectedObjectPositionChanged));
		}
	}

	verify(objects: Object3D[], newRotations: Euler[], oldRotations: Euler[])
	{
		if (objects.length === 0 || objects.length !== newRotations.length || objects.length !== oldRotations.length)
		{return false;}

		for (let i = 0; i < objects.length; i++)
		{
			if (!MathUtils.areVectorsEqual(newRotations[i], oldRotations[i]))
			{
				return true;
			}
		}

		return false;
	}
}
